// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getFamiliesFactory, getLastWeeks } from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FamilyCountingBundleGroupAvailabilityTable from './components/family-counting-bundle-group-availability-table';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { getFamilyCountingBundleGroupAvailability } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class FamilyCountingBundleGroupAvailability extends Component {

    state = {
        familyTypes: [],
        lastWeeks: [],
        selectedFamilyType: '',
        selectedLastWeek: '',
        results: null,
        singleTableView: false
    };

    handleTextChange ( name, val ) {

        if ( name === 'singleTableView' ) {

            if ( val.target.checked ) {

                this.setState( {
                    singleTableView: val.target.checked
                } );

            } else {

                this.setState( {
                    singleTableView: val.target.checked
                } );
                // this.refresh();

            }

        }

    }

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'Y' ).then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getLastWeeks().then( response => {

            this.setState( {
                lastWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleLastWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedLastWeek ) {

            this.props.increaseCounter();

            const { selectedFamilyType } = this.state;
            const selectedLastWeekVal = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) )
                .weekNumber;

            getFamilyCountingBundleGroupAvailability( selectedFamilyType, selectedLastWeekVal )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            familyTypes, lastWeeks, selectedFamilyType, selectedLastWeek, results, singleTableView
        } = this.state;

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        const mapResults = [];
        const singleExcelTableResult = [];
        let k = 1;
        const additionalInfo = { unitName: this.props.unit.name };

        if ( results !== null && results.bundleAvailability !== null ) {

            results.bundleAvailability.forEach( bundle => {

                // FORECASTED AVAILABILITY
                let tableResult = [];
                bundle.familyAvailabilityList.forEach( family => {

                    const nestedTableTypeResult = [];
                    nestedTableTypeResult.constraintType=family.constraintType;
                    nestedTableTypeResult.sectionName = 'FORECASTED AVAILABILITY';
                    nestedTableTypeResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableTypeResult );

                    const nestedTableResult = [];
                    nestedTableResult.constraintType=family.constraintType;
                    nestedTableResult.itemDesc = family.item;
                    nestedTableResult.sectionName = 'FORECASTED AVAILABILITY';
                    nestedTableResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableResult );
                    singleExcelTableResult.push( nestedTableResult );

                    const nestedForecastTDResult = {};
                    nestedForecastTDResult.constraintType=family.constraintType;
                    nestedForecastTDResult.itemDesc = 'Forecast';
                    nestedForecastTDResult.sectionName = 'FORECASTED AVAILABILITY';
                    nestedForecastTDResult.unitName = additionalInfo.unitName;

                    const nestedOrderedTDResult = {};
                    nestedOrderedTDResult.constraintType=family.constraintType;
                    nestedOrderedTDResult.itemDesc = 'Total Ordered';
                    nestedOrderedTDResult.sectionName = 'FORECASTED AVAILABILITY';
                    nestedOrderedTDResult.unitName = additionalInfo.unitName;

                    const nestedRunningTDResult = {};
                    nestedRunningTDResult.constraintType=family.constraintType;
                    nestedRunningTDResult.itemDesc = 'Running Avail';
                    nestedRunningTDResult.sectionName = 'FORECASTED AVAILABILITY';
                    nestedRunningTDResult.unitName = additionalInfo.unitName;
                    let runningAvailQty=0;
                    Object.keys( family.availabilityDetails ).forEach( item => {

                        const forecastQty = family.availabilityDetails[item].forecast;
                        const totalorderedQty = family.availabilityDetails[item].totalordered;
                        runningAvailQty=runningAvailQty+( forecastQty - totalorderedQty);
                        nestedForecastTDResult[item] = forecastQty;
                        nestedOrderedTDResult[item] = totalorderedQty;
                        nestedRunningTDResult[item] = runningAvailQty;

                    } );
                    tableResult.push( nestedForecastTDResult );
                    tableResult.push( nestedOrderedTDResult );
                    tableResult.push( nestedRunningTDResult );
                    singleExcelTableResult.push( nestedForecastTDResult );
                    singleExcelTableResult.push( nestedOrderedTDResult );
                    singleExcelTableResult.push( nestedRunningTDResult );

                } );

                let tempResultWithUnitName = tableResult
                    .map( i => ( { ...i, ...additionalInfo } ) );
                mapResults[k] = tempResultWithUnitName;
                mapResults[k].titleName = 'FORECASTED AVAILABILITY';
                k += 1;

                // ATP AVAILABILITY:F
                tableResult = [];
                bundle.familyAvailabilityList.forEach( family => {

                    const nestedTableTypeResult = [];
                    nestedTableTypeResult.constraintType=family.constraintType;
                    nestedTableTypeResult.sectionName = 'ATP AVAILABILITY';
                    nestedTableTypeResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableTypeResult );

                    const nestedTableResult = [];
                    nestedTableResult.constraintType=family.constraintType;
                    nestedTableResult.itemDesc = family.item;
                    nestedTableResult.sectionName = 'ATP AVAILABILITY';
                    nestedTableResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableResult );
                    singleExcelTableResult.push( nestedTableResult );

                    const nestedCapacityTDResult = {};
                    nestedCapacityTDResult.constraintType=family.constraintType;
                    nestedCapacityTDResult.itemDesc = 'Total Capacity';
                    nestedCapacityTDResult.sectionName = 'ATP AVAILABILITY';
                    nestedCapacityTDResult.unitName = additionalInfo.unitName;

                    const nestedOrderedTDResult = {};
                    nestedOrderedTDResult.constraintType=family.constraintType;
                    nestedOrderedTDResult.itemDesc = 'Total Ordered';
                    nestedOrderedTDResult.sectionName = 'ATP AVAILABILITY';
                    nestedOrderedTDResult.unitName = additionalInfo.unitName;

                    const nestedRunningTDResult = {};
                    nestedRunningTDResult.constraintType=family.constraintType;
                    nestedRunningTDResult.itemDesc = 'Running Avail';
                    nestedRunningTDResult.sectionName = 'ATP AVAILABILITY';
                    nestedRunningTDResult.unitName = additionalInfo.unitName;
                    let runningAvailQty=0;
                    Object.keys( family.availabilityDetails ).forEach( item => {

                        const totalCapacityQty = family.availabilityDetails[item].totalCapacity;
                        const totalorderedQty = family.availabilityDetails[item].totalordered;
                        runningAvailQty = runningAvailQty+(totalCapacityQty - totalorderedQty);
                        nestedCapacityTDResult[item] = totalCapacityQty;
                        nestedOrderedTDResult[item] = totalorderedQty;
                        nestedRunningTDResult[item] = runningAvailQty;

                    } );
                    tableResult.push( nestedCapacityTDResult );
                    tableResult.push( nestedOrderedTDResult );
                    tableResult.push( nestedRunningTDResult );

                    singleExcelTableResult.push( nestedCapacityTDResult );
                    singleExcelTableResult.push( nestedOrderedTDResult );
                    singleExcelTableResult.push( nestedRunningTDResult );

                } );

                tempResultWithUnitName = tableResult
                    .map( i => ( { ...i, ...additionalInfo } ) );
                mapResults[k] = tempResultWithUnitName;
                mapResults[k].titleName = 'ATP AVAILABILITY';
                k += 1;

                // ATP GROUP AVAILABILITY--G
                tableResult = [];
                bundle.groupAvailabilityList.forEach( family => {

                    const nestedTableTypeResult = [];
                    nestedTableTypeResult.constraintType=family.constraintType;
                    nestedTableTypeResult.sectionName = 'ATP GROUP AVAILABILITY';
                    nestedTableTypeResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableTypeResult );

                    const nestedTableResult = [];
                    nestedTableResult.constraintType=family.constraintType;
                    nestedTableResult.itemDesc = family.item;
                    nestedTableResult.sectionName = 'ATP GROUP AVAILABILITY';
                    nestedTableResult.unitName = additionalInfo.unitName;
                    tableResult.push( nestedTableResult );
                    singleExcelTableResult.push( nestedTableResult );

                    const nestedCapacityTDResult = {};
                    nestedCapacityTDResult.constraintType=family.constraintType;
                    nestedCapacityTDResult.itemDesc = 'Total Capacity';
                    nestedCapacityTDResult.sectionName = 'ATP GROUP AVAILABILITY';
                    nestedCapacityTDResult.unitName = additionalInfo.unitName;

                    const nestedOrderedTDResult = {};
                    nestedOrderedTDResult.constraintType=family.constraintType;
                    nestedOrderedTDResult.itemDesc = 'Total Ordered';
                    nestedOrderedTDResult.sectionName = 'ATP GROUP AVAILABILITY';
                    nestedOrderedTDResult.unitName = additionalInfo.unitName;

                    const nestedRunningTDResult = {};
                    nestedRunningTDResult.constraintType=family.constraintType;
                    nestedRunningTDResult.itemDesc = 'Total Avail';
                    nestedRunningTDResult.sectionName = 'ATP GROUP AVAILABILITY';
                    nestedRunningTDResult.unitName = additionalInfo.unitName;
                    
                    Object.keys( family.availabilityDetails ).forEach( item => {

                        const totalCapacityQty = family.availabilityDetails[item].totalCapacity;
                        const totalorderedQty = family.availabilityDetails[item].totalordered;
                        const runningAvailQty = totalCapacityQty - totalorderedQty;
                        nestedCapacityTDResult[item] = totalCapacityQty;
                        nestedOrderedTDResult[item] = totalorderedQty;
                        nestedRunningTDResult[item] = runningAvailQty;

                    } );
                    tableResult.push( nestedCapacityTDResult );
                    tableResult.push( nestedOrderedTDResult );
                    tableResult.push( nestedRunningTDResult );
                    singleExcelTableResult.push( nestedCapacityTDResult );
                    singleExcelTableResult.push( nestedOrderedTDResult );
                    singleExcelTableResult.push( nestedRunningTDResult );

                } );
                tempResultWithUnitName = [];
                tempResultWithUnitName = tableResult
                    .map( i => ( { ...i, ...additionalInfo } ) );
                mapResults[k] = tempResultWithUnitName;
                mapResults[k].titleName = 'ATP GROUP AVAILABILITY';
                k += 1;

            } );

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Family, Counting Bundle, & Group Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-family-counting-bundle-group-availability-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-family-counting-bundle-group-availability-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />

                                <OptionsDropDown
                                    className="atp-family-counting-bundle-group-availability-select"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleLastWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Last Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />

                                {selectedFamilyType && selectedLastWeek && (
                                <>
                                    <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" />

                                    </span>

                                    <LabeledInput
                                        className="singleTableView"
                                        name="singleTableView"
                                        isEditable={true}
                                        label="Single Table View"
                                        type="checkbox"

                                        onChange={this.handleTextChange.bind( this, 'singleTableView' )}
                                        value={singleTableView}
                                        isRequired={false}
                                    />
                                </>
                                )}

                            </div>
                        </div>
                        {selectedFamilyType && selectedLastWeek && singleTableView && (
                            <FamilyCountingBundleGroupAvailabilityTable
                                results={singleExcelTableResult}
                                titleName=""
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                                type="Single"
                            />
                        )}

                        {selectedFamilyType && selectedLastWeek && !singleTableView &&
                        mapResults !== null && mapResults.map( ( item, index ) => (

                            <FamilyCountingBundleGroupAvailabilityTable
                                key={`family-counting-${index}`}
                                results={item}
                                titleName={item.titleName}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                                type="Multiple"
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

FamilyCountingBundleGroupAvailability.displayName = 'FamilyCountingBundleGroupAvailability';
FamilyCountingBundleGroupAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( FamilyCountingBundleGroupAvailability ) );
